import { Component } from 'react';
import {connect} from 'react-redux';
import {Container} from 'react-bootstrap';
import UserGroupsList from './usergroups-list';
import PageTitle from '../../../common/page-title/index';
import LinkButton from '../../../common/link-button';
import {getUserGroups} from '../../../../actions/usergroups';

import './styles.css';

class UserGroups extends Component {
  UNSAFE_componentWillMount() {
    this.props.dispatch(getUserGroups());
  }

  render() {
    return (
      <Container fluid className="usergroups">
        <PageTitle>
          User groups
        </PageTitle>
        <LinkButton
          to="/admin/user-groups/new"
          arrow={false}
          className="add-usergroup"
          color="red"
          permissions={{
            action: 'create',
            subjectClass: 'UserGroup'
          }}
          submit={false}
        >
          Add usergroup
        </LinkButton>

        <UserGroupsList
          fetched={this.props.fetched}
          fetching={this.props.fetching}
          userGroups={this.props.userGroups}
        />
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  userGroups: state.userGroups.userGroups,
  fetched: state.userGroups.fetched,
  fetching: state.userGroups.fetching,
});

export default connect(mapStateToProps)(UserGroups);
